import { Controller } from "@hotwired/stimulus"

// The import page's Email check card (Email_Verification_Feedback_Plan.md,
// B): polls the import's counts while checks are still pending and paints
// them in place, with a fix link per failed row. She can close the tab; the
// checks keep landing and the page is right whenever she comes back.
export default class extends Controller {
  static targets = ["ok", "unconfirmed", "invalidCount", "invalidList", "status"]
  static values = { url: String, pending: Number, interval: { type: Number, default: 3000 } }

  connect() {
    // Always read once: a page restored from the back button is stale.
    this.poll()
    if (this.pendingValue > 0) this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (!this.timer) this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!res.ok) return
      const c = await res.json()
      this.paint(c)
      if (c.pending === 0) this.stop()
      else this.start()
    } catch (e) {
      // A missed poll is nothing; the next one catches up.
    }
  }

  paint(c) {
    const set = (name, value) => { if (this[`has${name[0].toUpperCase()}${name.slice(1)}Target`]) this[`${name}Target`].textContent = value }
    set("ok", c.ok)
    set("unconfirmed", c.unconfirmed)
    set("invalidCount", c.invalid)
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = c.pending > 0
        ? `Checking ${c.total} addresses, usually under a minute. ${c.total - c.pending} checked so far.`
        : `All ${c.total} addresses checked.`
    }
    if (this.hasInvalidListTarget) {
      this.invalidListTarget.innerHTML = c.invalid_rows.map((r) => `
        <li class="flex items-center justify-between gap-3 py-2 border-b border-[#E8E4DF] last:border-b-0">
          <div class="min-w-0">
            <span class="text-sm text-[#2D2D2D]">${this.esc(r.name)}</span>
            <span class="text-sm text-[#8C8C8C] ml-2">${this.esc(r.email)}</span>
          </div>
          <a href="${this.esc(r.fix_url)}" class="text-xs font-medium text-[#C4A484] hover:underline whitespace-nowrap">Fix</a>
        </li>`).join("")
    }
  }

  esc(text) {
    const div = document.createElement("div")
    div.textContent = text || ""
    return div.innerHTML
  }
}
